import React from 'react'
import PropTypes from 'prop-types'
import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'

import {
  _MapBoxMarker,
  _MarkerContent,
} from './styles'

const Marker = ({
  lat,
  lng,
  url,
  onMouseEnter,
  children,
  onClick,
  mobileModalChildren,
  mobileModalKey,
}) => {
  if(!(lat && lng)) return null
  let markerContents = children
  if(onClick) {
    markerContents = (
      <_MarkerContent
        data-test-id="onClickDiv"
        onMouseEnter={onMouseEnter}
        onClick={onClick}
      />
    )
  } else if(url) {
    markerContents = (
      <AppLinkMobileCtrl
        to={`/${url}`}
        aria-label={`nearby listing ${url}`}
        mobileModalChildren={mobileModalChildren}
        mobileModalKey={mobileModalKey}
      >
        <_MarkerContent
          onMouseEnter={onMouseEnter}
        />
      </AppLinkMobileCtrl>
    )
  }
  return (
    <_MapBoxMarker
      latitude={lat}
      longitude={lng}
      enableLink={(url || onClick || children)}
    >
      {markerContents}
    </_MapBoxMarker>
  )
}

Marker.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  url: PropTypes.string,
  onMouseEnter: PropTypes.func,
  children: PropTypes.node,
  onClick: PropTypes.node,
  mobileModalChildren: PropTypes.func,
  mobileModalKey: PropTypes.string,
}

export default React.memo(Marker)
